export default "__VITE_ASSET__CuBkCMkJ__"